import { render, staticRenderFns } from "./uf_okpo.vue?vue&type=template&id=71a9e450&scoped=true"
import script from "./uf_okpo.vue?vue&type=script&lang=js"
export * from "./uf_okpo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a9e450",
  null
  
)

export default component.exports